export enum ReportPeriod {
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year'
}
